<template lang="html">
    <div
        class="activity-indicator"
    >
        <i
            class="activity-indicator-icon fa-spin"
            :class="iconClasses"
        />
        <div class="activity-indicator-text has-text-white-ter is-italic has-text-weight-semibold is-flex">
            <span v-text="overlayText" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        overlayText: {
            type: String,
            default: 'Loading...',
        },
        pack: {
            type: String,
            default: 'fas',
        },
        icon: {
            type: String,
            default: 'fa-cog',
        },
    },

    computed: {
        iconClasses() {
            return [
                this.pack,
                this.icon,
            ];
        },
    },
};
</script>

<style lang="scss">
.activity-indicator {
    // bulma variables
    $dark: #363636 !default;

    position: absolute;
    top: 2rem;
    right: 2rem;
    pointer-events: none;

    .activity-indicator-icon {
        font-size: 12vh;
        opacity: 0.6;
    }

    .activity-indicator-text {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        align-items: center;
        justify-content: center;
        text-shadow: 0 1px 3px $dark;
    }
}
</style>
